import React from 'react'
import MemberApplicationTaskListDetailForm from '../../features/MemberApplicationTaskListDetailForm/MemberApplicationTaskListDetailForm'
import './MemberApplicationTaskListDetailForm.scss'

const MemberApplicationTaskListDetail = () => {
  return (
    <div>
      <MemberApplicationTaskListDetailForm />
    </div>
  )
}

export default MemberApplicationTaskListDetail
